import {combineReducers} from '@reduxjs/toolkit'
import {analyticDetailReducer} from 'features/Analytics/Detail/analyticsDetailSlice'
import {analyticsLogsDownloadReducer} from 'features/Analytics/Downloads/AnalyticsLogs/slice'
import {violationsLogsDownloadReducer} from 'features/Analytics/Downloads/ViolationsLogs/slice'
import {
  overviewAnalyticsReducer,
  overviewViolationsReducer,
} from 'features/Analytics/Overview/analyticsOverviewSlice'
import {analyticPolicyTopBlocksReducer} from 'features/Analytics/Policy/analyticsPolicySlice'
import {
  analyticsActivityByTimeReducer,
  analyticsTopCategoriesReducer,
  productivitySearchInputsReducer,
  topCategoriesTimeStampReducer,
} from 'features/Analytics/Productivity/analyticsProductivitySlice'
import {analyticsShadowITReducer} from 'features/Analytics/ShadowIT/analyticsShadowITSlice'
import {endpointsReducer} from 'features/Endpoints/endpointsSlice'
import {policiesReducer} from 'features/Policies/policiesSlice'
import {settingsReducer} from 'features/Settings'
import {userReducer} from 'features/User/userSlice'

export const appReducers = {
  user: userReducer,
  settings: settingsReducer,
  endpoints: endpointsReducer,
  policies: policiesReducer,
  analyticsShadowIT: analyticsShadowITReducer,
  analyticsProductivity: combineReducers({
    topCategories: analyticsTopCategoriesReducer,
    activityByTime: analyticsActivityByTimeReducer,
    searchInputs: productivitySearchInputsReducer,
    topCategoriesRenderTimeStamp: topCategoriesTimeStampReducer,
  }),
  analyticsPolicy: combineReducers({
    topTenBlocks: analyticPolicyTopBlocksReducer,
  }),
  analyticsOverview: combineReducers({
    violations: overviewViolationsReducer,
    analytics: overviewAnalyticsReducer,
  }),
  analyticsDetail: analyticDetailReducer,
  analyticsDownload: combineReducers({
    analytics: analyticsLogsDownloadReducer,
    violations: violationsLogsDownloadReducer,
  }),
}
